
// import React, { useState } from 'react';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import {
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Divider,
//   IconButton,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Button,
// } from '@mui/material';
// import { RxDashboard } from 'react-icons/rx';
// import { FaBars } from 'react-icons/fa6';
// import { BsListCheck } from 'react-icons/bs';
// import { MdOutlineQueryStats } from 'react-icons/md';
// import Logo from '../../landpageimage1/startuplogobaner.png'; // Replace with your actual logo path

// function StudentSidebar({ isSidebarCollapsed, toggleSidebar }) {
//   const location = useLocation(); // Get the current location
//   const navigate = useNavigate(); // Navigation hook
//   const [selected, setSelected] = useState(location.pathname); // Track selected menu item
//   const [isLogoutDialogOpen, setIsLogoutDialogOpen] = useState(false); // State for logout dialog

//   const handleItemClick = (path) => {
//     setSelected(path); // Update the selected item on click
//   };

//   const handleLogout = () => {
//     // Clear local storage and navigate to the login page
//     localStorage.clear();
//     navigate('/Login@punestartupexpo');
//   };

//   const menuItems = [
//     { label: 'Home', icon: <RxDashboard />, path: '/StudentApp/' },
//     { label: 'Status', icon: <BsListCheck />, path: '/StudentApp/StudentStatus' },
//     { label: 'Tracking', icon: <MdOutlineQueryStats />, path: '/StudentApp/StudentTrack' },
//   ];

//   return (
//     <>
//       <Drawer
//         variant="permanent"
//         sx={{
//           width: isSidebarCollapsed ? 80 : 300,
//           flexShrink: 0,
//           '& .MuiDrawer-paper': {
//             width: isSidebarCollapsed ? 80 : 300,
//             boxSizing: 'border-box',
//             transition: 'width 0.3s ease',
//             background: 'linear-gradient(to bottom,rgb(1, 23, 32),rgb(1, 45, 65))',
//             color: '#FFFFFF',
//           },
//         }}
//       >
//         {/* Logo Section */}
//         <div
//           className={`logo-container ${isSidebarCollapsed ? 'collapsed' : ''}`}
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: isSidebarCollapsed ? 'center' : 'flex-start',
//             padding: '20px',
//             background: 'linear-gradient(to right,rgb(1, 23, 32),rgb(1, 45, 65))',
//             textAlign: 'center',
//           }}
//         >
//           {!isSidebarCollapsed && <img src={Logo} alt="Logo" style={{ width: '150px' }} />}
//           {isSidebarCollapsed && <img src={Logo} alt="Logo" style={{ width: '40px' }} />}
//           <IconButton
//             onClick={toggleSidebar}
//             sx={{
//               marginLeft: 'auto',
//               color: '#FFFFFF',
//             }}
//           >
//             <FaBars />
//           </IconButton>
//         </div>

//         <Divider
//           sx={{
//             backgroundColor: 'rgba(255, 255, 255, 0.3)',
//           }}
//         />

//         {/* Menu Items */}
//         <List>
//           {menuItems.map((item) => (
//             <ListItem
//               button
//               key={item.path}
//               component={Link}
//               to={item.path}
//               onClick={() => handleItemClick(item.path)}
//               sx={{
//                 borderRadius: '8px',
//                 margin: '8px 12px',
//                 color: '#FFFFFF',
//                 backgroundColor: selected === item.path ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
//                 '&:hover': {
//                   backgroundColor: 'rgba(255, 255, 255, 0.2)',
//                 },
//               }}
//             >
//               <ListItemIcon
//                 sx={{
//                   color: '#FFFFFF',
//                 }}
//               >
//                 {item.icon}
//               </ListItemIcon>
//               {!isSidebarCollapsed && <ListItemText primary={item.label} />}
//             </ListItem>
//           ))}
//         </List>

//         {/* Logout Section */}
//         <div
//           className="logout-button"
//           style={{
//             position: 'absolute',
//             bottom: '20px',
//             width: isSidebarCollapsed ? 'calc(100% - 20px)' : 'calc(100% - 40px)',
//             margin: isSidebarCollapsed ? '0 10px' : '0 20px',
//             backgroundColor: 'rgba(255, 255, 255, 0.2)',
//             borderRadius: '8px',
//             padding: '8px',
//             textAlign: 'center',
//             color: '#FFFFFF',
//             cursor: 'pointer',
//           }}
//           onClick={() => setIsLogoutDialogOpen(true)} // Open the logout dialog
//         >
//           <ListItem
//             button
//             sx={{
//               color: '#FFFFFF',
//               '&:hover': {
//                 backgroundColor: 'rgba(255, 255, 255, 0.3)',
//               },
//             }}
//           >
//             <ListItemIcon>
//               <FaBars />
//             </ListItemIcon>
//             {!isSidebarCollapsed && <ListItemText primary="Logout" />}
//           </ListItem>
//         </div>
//       </Drawer>

//       {/* Logout Confirmation Dialog */}
//       <Dialog
//         open={isLogoutDialogOpen}
//         onClose={() => setIsLogoutDialogOpen(false)}
//         aria-labelledby="logout-dialog-title"
//       >
//         <DialogTitle id="logout-dialog-title">Confirm Logout</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to logout?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setIsLogoutDialogOpen(false)} color="primary">
//             No
//           </Button>
//           <Button onClick={handleLogout} color="primary" autoFocus>
//             Yes
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// }

// export default StudentSidebar;



import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';
import { RxDashboard } from 'react-icons/rx';
import { FaBars, FaRightFromBracket } from 'react-icons/fa6';
import { BsListCheck } from 'react-icons/bs';
import { MdOutlineQueryStats } from 'react-icons/md';
import Logo from '../../landpageimage1/startuplogobaner.png'; // Replace with your actual logo path

const themeColors = {
  primary: '#FF6F00',
  background: '#FFFFFF',
  hover: 'rgba(255, 111, 0, 0.2)',
};

function StudentSidebar({ isSidebarCollapsed, toggleSidebar }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [selected, setSelected] = useState(location.pathname);
  const [isLogoutDialogOpen, setIsLogoutDialogOpen] = useState(false);

  const handleItemClick = (path) => {
    setSelected(path);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/Login@punestartupexpo');
  };

  const menuItems = [
    { label: 'Home', icon: <RxDashboard />, path: '/StudentApp/' },
    { label: 'Status', icon: <BsListCheck />, path: '/StudentApp/StudentStatus' },
    { label: 'Tracking', icon: <MdOutlineQueryStats />, path: '/StudentApp/StudentTrack' },
  ];

  return (
    <>
      <Drawer
        variant="permanent"
        sx={{
          width: isSidebarCollapsed ? 80 : 280,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: isSidebarCollapsed ? 80 : 280,
            boxSizing: 'border-box',
            transition: 'width 0.3s ease',
            background: themeColors.primary,
            color: themeColors.background,
          },
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: isSidebarCollapsed ? 'center' : 'space-between',
            padding: '20px',
            background: themeColors.primary,
            textAlign: 'center',
          }}
        >
          {!isSidebarCollapsed && <img src={Logo} alt="Logo" style={{ width: '150px' }} />}
          {isSidebarCollapsed && <img src={Logo} alt="Logo" style={{ width: '40px' }} />}
          <IconButton
            onClick={toggleSidebar}
            sx={{ color: themeColors.background }}
          >
            <FaBars />
          </IconButton>
        </div>

        <Divider sx={{ backgroundColor: themeColors.background }} />

        <List>
          {menuItems.map((item) => (
            <ListItem
              button
              key={item.path}
              component={Link}
              to={item.path}
              onClick={() => handleItemClick(item.path)}
              sx={{
                borderRadius: '8px',
                margin: '8px 12px',
                color: themeColors.background,
                backgroundColor: selected === item.path ? themeColors.hover : 'transparent',
                '&:hover': {
                  backgroundColor: themeColors.hover,
                },
              }}
            >
              <ListItemIcon sx={{ color: themeColors.background }}>
                {item.icon}
              </ListItemIcon>
              {!isSidebarCollapsed && <ListItemText primary={item.label} />}
            </ListItem>
          ))}
        </List>

        <div
          style={{
            position: 'absolute',
            bottom: '20px',
            width: isSidebarCollapsed ? 'calc(100% - 20px)' : 'calc(100% - 40px)',
            margin: isSidebarCollapsed ? '0 10px' : '0 20px',
            backgroundColor: themeColors.hover,
            borderRadius: '8px',
            padding: '8px',
            textAlign: 'center',
            color: themeColors.background,
            cursor: 'pointer',
          }}
          onClick={() => setIsLogoutDialogOpen(true)}
        >
          <ListItem
            button
            sx={{ color: themeColors.background }}
          >
            <ListItemIcon>
              <FaRightFromBracket />
            </ListItemIcon>
            {!isSidebarCollapsed && <ListItemText primary="Logout" />}
          </ListItem>
        </div>
      </Drawer>

      <Dialog
        open={isLogoutDialogOpen}
        onClose={() => setIsLogoutDialogOpen(false)}
        aria-labelledby="logout-dialog-title"
      >
        <DialogTitle id="logout-dialog-title">Confirm Logout</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsLogoutDialogOpen(false)} color="primary">
            No
          </Button>
          <Button onClick={handleLogout} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default StudentSidebar;
